

import Async from "../../components/Async";

import BlogEditorPage from "../../pages/marketing/blog/blogEditorPage";

const AuthGuard = Async(() => import('../auth.guard'));

const routes = {
    blogEditorSpecific: {
        id: 'blogEditorSpecific',
        name: 'Editor de Blog',
        path: '/blog/editor/:id',
        component: BlogEditorPage,
        roles: ['admin'],
        layoutProps: {
            hideSideBar: true,
        },
        guard: AuthGuard,
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages
}